module.exports = __webpack_public_path__ + "static/media/accountArrow.14b3c003.svg";